module.exports = __webpack_public_path__ + "img/38.bfd01fed.png";